import { useAsync } from "@react-hookz/web";
import { type FunctionComponent, useEffect } from "react";
import { fetchQuery, graphql, useRelayEnvironment } from "react-relay";

import type { bookmarkItemsQuery } from "scmp-app/queries/__generated__/bookmarkItemsQuery.graphql";

import { BookmarkItems as BookmarkItem } from "./item";
import { Container } from "./styles";
export type Props = {
  bookmarks: string[];
  className?: string;
};

export const BookmarkItems: FunctionComponent<Props> = ({ bookmarks, className }) => {
  const environment = useRelayEnvironment();

  const [contents, { execute }] = useAsync(async () => {
    const data = await fetchQuery<bookmarkItemsQuery>(
      environment,
      graphql`
        query bookmarkItemsQuery($entityIds: [String]) {
          contents(filter: { entityIds: $entityIds }, first: 3, contentTypes: ARTICLE) {
            edges {
              node {
                ...itemBookmarkItemsContent
              }
            }
          }
        }
      `,
      {
        entityIds: bookmarks,
      },
      {
        fetchPolicy: "store-or-network",
      },
    ).toPromise();

    return data;
  });

  useEffect(() => {
    void execute();
  }, [bookmarks, execute]);

  if (bookmarks.length === 0) {
    return null;
  }

  return (
    <Container className={className}>
      {contents.result?.contents.edges.map((edge, index) => (
        <BookmarkItem key={index} reference={edge.node} />
      ))}
    </Container>
  );
};

BookmarkItems.displayName = "BookmarkItems";
